import { queryOptions } from '@tanstack/react-query'

import { fetchManifest } from '#admin/features/tenant/api.ts'

/**
 * The manifest is loaded once, in the authenticated layout, and read everywhere.
 *
 * A long `staleTime` because a module's access level changes when somebody's plan changes,
 * which is a thing that happens on the order of months — refetching it per navigation would
 * be a request per page for an answer that has not moved.
 */
export const manifestQuery = () =>
  queryOptions({
    queryKey: ['tenant', 'manifest'],
    queryFn: ({ signal }) => fetchManifest(signal),
    staleTime: 5 * 60_000,
  })
